import { KeyboardEvent } from 'react';
import { insertMention } from './withMentions';
import { BaseRange, BaseSelection, Editor, Transforms } from 'slate';
import { BaseMention, CustomEditor, SlateStateActionsWithValues } from '../../../../models/slate-editor';

const hasAnchorGuard = (selection: BaseSelection): selection is BaseRange => !!(selection && 'anchor' in selection);

export const onKeyDown =
  (
    event: KeyboardEvent<HTMLDivElement>,
    editor: CustomEditor
  ): ((actions: SlateStateActionsWithValues, mentions: BaseMention[] | undefined) => void) =>
  (actions: SlateStateActionsWithValues, mentions: BaseMention[] | undefined): void => {
    const { target, setTarget, index, setIndex, transformType, setTransformType, setSearch, setDirection } = actions;
    if (target && transformType === 'mention') {
      if (!mentions) {
        return;
      }
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          const prevIndex = index >= mentions.length - 1 ? 0 : index + 1;
          setIndex(prevIndex);
          break;
        case 'ArrowUp':
          event.preventDefault();
          const nextIndex = index <= 0 ? mentions.length - 1 : index - 1;
          setIndex(nextIndex);
          break;
        case 'Tab':
        case 'Enter':
          event.preventDefault();
          Transforms.select(editor, target);
          insertMention(editor, mentions[index], target);
          setTarget(null);
          setTransformType(null);
          break;
        case 'Escape':
          event.stopPropagation();
          event.preventDefault();
          setTarget(null);
          setTransformType(null);
          break;
      }
    } else {
      switch (event.key) {
        case 'ArrowLeft':
          setDirection('left');
          break;
        case ' ': {
          const { selection } = editor;
          if (!hasAnchorGuard(selection)) return;
          const { anchor } = selection;

          // Get the current character before the cursor
          const textBefore = Editor.string(editor, {
            anchor: { path: anchor.path, offset: anchor.offset - 1 },
            focus: anchor
          });
          const textAfter = Editor.string(editor, {
            anchor,
            focus: { path: anchor.path, offset: anchor.offset + 1 }
          });
          // Prevent adding a space if the last character is also a space
          if ((textBefore && textBefore.endsWith(' ')) || (textAfter && textAfter.startsWith(' '))) {
            event.preventDefault();
            // setShowToasterForDoubleSpaces(true);
          }
          break;
        }
        default:
          setDirection(null);
          break;
      }
      setTarget(null);
      setTransformType(null);
      setIndex(0);
      setSearch('');
    }
  };
